import { render, staticRenderFns } from "./studentDocuments.vue?vue&type=template&id=78f46a66&"
import script from "./studentDocuments.vue?vue&type=script&lang=ts&"
export * from "./studentDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports